import { supabase } from '../supabase';

export const ARCHIVED_SUBJECT_REASON = 'Subject removed from parent-teacher assignment';

export const NOT_ARCHIVED_SUBJECT_ENROLMENT = `withdrawn_reason.is.null,withdrawn_reason.neq."${ARCHIVED_SUBJECT_REASON}"`;

export interface ArchivedSubjectScope {
  classId?: string | null;
  studentId?: string | null;
  courseIds?: string[];
}

export async function fetchArchivedSubjectCourseIds(scope: ArchivedSubjectScope = {}): Promise<Set<string>> {
  if (scope.courseIds && scope.courseIds.length === 0) return new Set();
  let archivedQuery = supabase
    .from('course_enrollments')
    .select('course_id')
    .eq('status', 'withdrawn')
    .eq('withdrawn_reason', ARCHIVED_SUBJECT_REASON);
  if (scope.classId) archivedQuery = archivedQuery.eq('class_id', scope.classId);
  if (scope.studentId) archivedQuery = archivedQuery.eq('student_id', scope.studentId);
  if (scope.courseIds) archivedQuery = archivedQuery.in('course_id', scope.courseIds);
  const { data: archived, error: archivedErr } = await archivedQuery;
  if (archivedErr) return new Set();
  const archivedIds = [...new Set((archived ?? []).map((r) => r.course_id as string).filter(Boolean))];
  if (archivedIds.length === 0) return new Set();

  let activeQuery = supabase
    .from('course_enrollments')
    .select('course_id')
    .eq('status', 'active')
    .in('course_id', archivedIds);
  if (scope.studentId) activeQuery = activeQuery.eq('student_id', scope.studentId);
  const { data: active, error: activeErr } = await activeQuery;
  if (activeErr) return new Set();
  const activeIds = new Set((active ?? []).map((r) => r.course_id as string));
  return new Set(archivedIds.filter((id) => !activeIds.has(id)));
}
